import { TFunction } from 'i18next';
import Joi from 'joi';

//the field labels the task validation puts in its messages
export const getTaskValidationLabels = (t: TFunction) => ({
  assignment: t('task:Assignment.Label'),
  startDateTime: t('task:Start.Label'),
  endDateTime: t('task:End.ErrorMessage'),
  name: t('task:Name.Label'),
  deadline: t('task:Deadline.ErrorMessage'),
});

//the message of the validation error that belongs to the field
export const findTaskFieldError = (err: Joi.ValidationError | undefined, fieldName: string): string | undefined => {
  if (!err) return undefined;

  const fieldError = err.details.find((e) => {
    return e.context?.key === fieldName || e.message.toLowerCase().includes(fieldName.toLowerCase());
  });

  return fieldError?.message;
};
